"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = _interopRequireDefault(require("../AppFrame/constants"));
const SessionStorage = {
  get(name) {
    return JSON.parse(sessionStorage.getItem(name));
  },
  getTheme() {
    return sessionStorage.getItem(_constants.default.THEME_KEY);
  },
  set(name, data) {
    sessionStorage.setItem(name, JSON.stringify(data));
  },
  remove(name) {
    sessionStorage.removeItem(name);
  },
  clear() {
    sessionStorage.clear();
  }
};
var _default = exports.default = SessionStorage;